module.exports = ".modal-dialog {\n  width: 40%;\n  max-width: none;\n  max-height: 95%;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/order-view-modal/order-view-modal.component.scss
// module id = ./src/app/account-client/component/account-client-details/order-view-modal/order-view-modal.component.scss
// module chunks = main